module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0100.jpg?v=9ccea66f";